import React, { useEffect, useState } from "react";
//import "../../antdstyle.css";
//import "antd/dist/antd.css";

import mixins from "./mixins";

const CreditInfoPage = (props) => {
  const [infoData, setInfoData] = useState({});
  useEffect(() => {
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
  });

  useEffect(()=>{
    if(props.urlparams.application_id) {
      props.api.apiGetRequirement(props.urlparams).then((response)=>{
        setInfoData(response.data);
      });
    }
  },[]);

  console.log({infoData});

  let links = mixins.links;
  let creditInfoFields = [
    {
      name: "fund_required",
      label: "Tell us your requirements in Cr",
      placeholder: "Enter value in Cr",
      type: "number",
    },
    // {
    //   name: "expected_tenor",
    //   label: "Expected Tenor (years)",
    //   placeholder: "Enter value in Cr",
    //   type: "number",
    //   required: true,
    // },
    {
      name: "expected_roi",
      label: "Expected interest rate(%)",
      type: "number",
      step:"any",
      required: true,
    },
    {
      name: "fund_usage_type",
      label: "Select your end use",
      type: "select",
      options: enums.fundUsageTypes.options(),
      required: true,
    },
    {
      name: "remarks",
      label: "Remarks",
      type: "text",
    },
  ];

  const submitForm = (e,data)=>{
    let payload = Object.except(data,['purchase_bill','sale_bill','dealer_finance','vendor_finance']);
    payload.bill_type = [
      ...(data.purchase_bill!==undefined?["purchase_bill"]:[]),
      ...(data.sale_bill!==undefined?["sale_bill"]:[]),
      ...(data.dealer_finance!==undefined?["dealer_finance"]:[]),
      ...(data.vendor_finance!==undefined?["vendor_finance"]:[])
    ]
    console.log({payload});
    //return;
    if(props.urlparams.application_id) {
      props.api.apiPutRequirement(payload).then((response)=>{
        let data = response.data;
        navigate(`/app/credit_list/credit_info/doc_upload?application_id=${data.application_id}`);
      });
    } else {
      props.api.apiPostRequirement(payload).then((response)=>{
        let data = response.data;
        navigate(`/app/credit_list/credit_info/doc_upload?application_id=${data.application_id}`);
      });
    }
  }

  return (
    <AppWrapper
      title="Credit Info"
      back="Credits"
      backlink="/app/credit_list"
    >
      <AppLinkTabs data={links}></AppLinkTabs>
      <AppForm className="paper_container" onSubmit={submitForm}>
        <p className="section_title mandatory">Select your Requirements</p>
        {/* INFO-CARD */}
        <div className="card info_card">
          <div className="card-body px-4 py-3">
            <h5 className="card-title">Supply chain finance</h5>
            <h6 className="card-subtitle mb-2 text-muted">
              From Vendor and dealer financing to dynamic financing
            </h6>
            <div className="mt-4 radio_group_form d-flex align-items-center justify-content-between">
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value={"purchase_bill"}
                  name="purchase_bill"
                  id="PBD"
                  defaultChecked={infoData?.bill_type?.includes('purchase_bill')}
                />
                <label className="form-check-label" htmlFor="PBD">
                  Purchase Bill Discount
                </label>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="sale_bill"
                  value={"sale_bill"}
                  id="SBD"
                  defaultChecked={infoData?.bill_type?.includes('sale_bill')}
                />
                <label className="form-check-label" htmlFor="SBD">
                  Sale Bill Discount
                </label>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="dealer_finance"
                  value={"dealer_finance"}
                  id="DF"
                  defaultChecked={infoData?.bill_type?.includes('dealer_finance')}
                />
                <label className="form-check-label" htmlFor="DF">
                  Dealer Finance
                </label>
              </div>
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="vendor_finance"
                  value={"vendor_finance"}
                  id="VF"
                  defaultChecked={infoData?.bill_type?.includes('vendor_finance')}
                />
                <label className="form-check-label" htmlFor="VF">
                  Vendor Finance
                </label>
              </div>
            </div>
          </div>
        </div>
        {/* INFO-CARD */}

        <div
          className="row mb-2"
        >
          {creditInfoFields.map((field, i) => (
            <div className="col-sm-6 col-md-4" key={i}>
              <AppInput {...field} defaultValue={infoData[field.name]}></AppInput>
            </div>
          ))}
          <div className="row align-items-center mt-3">
            <div className="col-12">
              <button className="btn add-btn">Save & Next</button>
            </div>
          </div>
        </div>
      </AppForm>
    </AppWrapper>
  );
};

export default connect(CreditInfoPage);
